import React, { memo, useCallback, useState } from "react";
import {
  StyledCheckIcon,
  BlackCopyButton,
} from "@/react/components/styled/StyledIcons";
import styled from "styled-components";

const CopyButtonWrapper = styled.div`
  cursor: pointer;
`;

export const CopyButton = memo(({ value, ...rest }) => {
  const [copied, setCopied] = useState(false);

  const copyValue = useCallback(
    (event) => {
      // Prevent the click event from propagating to the parent element
      // which may have its own callback set.
      event.stopPropagation();

      navigator.clipboard.writeText(value).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    },
    [value]
  );

  return (
    <CopyButtonWrapper
      className={"cell-copy-btn"}
      onClick={copyValue}
      data-testid="copy-button"
      {...rest}
    >
      {copied ? <StyledCheckIcon size="25" /> : <BlackCopyButton size="25" />}
    </CopyButtonWrapper>
  );
});
